import { render, staticRenderFns } from "./GetRewardModal.vue?vue&type=template&id=1ca070ac&scoped=true"
import script from "./GetRewardModal.vue?vue&type=script&lang=js"
export * from "./GetRewardModal.vue?vue&type=script&lang=js"
import style0 from "./GetRewardModal.vue?vue&type=style&index=0&id=1ca070ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca070ac",
  null
  
)

export default component.exports